<template>
    <ui5-dialog
        ref="dialog"
        :header-text="trans('pages.recurring.delete_dialog_header')"
        class="recurring-scope-dialog"
    >
        <div class="dialog-content">
            <p class="question">{{ trans('pages.recurring.delete_scope_question') }}</p>

            <div
                class="option-container"
                @click="selectedScope = 'this'"
            >
                <div class="option-row">
                    <ui5-radio-button
                        name="scope"
                        value="this"
                        :checked="selectedScope === 'this'"
                        class="scope-radio"
                    />
                    <div class="option-content">
                        <strong>{{ trans('pages.recurring.delete_this_trip_only') }}</strong>
                        <p class="description">
                            {{ trans('pages.recurring.delete_this_trip_only_desc') }}
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="option-container"
                @click="selectedScope = 'this_and_following'"
            >
                <div class="option-row">
                    <ui5-radio-button
                        name="scope"
                        value="this_and_following"
                        :checked="selectedScope === 'this_and_following'"
                        class="scope-radio"
                    />
                    <div class="option-content">
                        <strong>{{ trans('pages.recurring.delete_this_and_following') }}</strong>
                        <p class="description">
                            {{ trans('pages.recurring.delete_this_and_following_desc') }}
                        </p>
                    </div>
                </div>
            </div>

            <ui5-message-strip
                v-if="selectedScope === 'this_and_following'"
                design="Warning"
                class="info-strip"
            >
                {{ trans('pages.recurring.delete_this_and_following_warning') }}
            </ui5-message-strip>
        </div>

        <div
            slot="footer"
            class="dialog-footer"
        >
            <ui5-button
                @click="confirm"
                class="delete-button"
            >
                {{ trans('pages.recurring.continue') }}
            </ui5-button>
            <ui5-button @click="cancel">
                {{ trans('pages.recurring.cancel') }}
            </ui5-button>
        </div>
    </ui5-dialog>
</template>

<script>
import localization from '../../mixins/localization';
import recurringScopeDialog from '../../mixins/recurring-scope-dialog';

export default {
    mixins: [localization, recurringScopeDialog]
};
</script>
